import { useQuery } from "@tanstack/react-query";
import { supabaseAgency } from "@/lib/supabase";

export interface TaskRow {
  task_id: string;
  identifier?: string;
  name: string;
  status: string;
  bucket: "overdue" | "due_today" | "due_this_week" | "later" | "done";
  due_date: string | null;
  priority: string | number | null;
  list_name?: string | null;
  project_name?: string | null;
  assignee_id: string | null;
  assignee_name: string | null;
  url: string | null;
  client: string | null;
  synced_at: string;
}

interface LinearIssueRow {
  issue_id: string;
  identifier: string;
  title: string;
  status: string;
  bucket: TaskRow["bucket"];
  due_date: string | null;
  priority: number | null;
  project_name: string | null;
  assignee_id: string | null;
  assignee_name: string | null;
  url: string | null;
  client: string | null;
  synced_at: string;
}

interface UseTasksOpts { client?: string }

export function useTasks(opts: UseTasksOpts = {}) {
  return useQuery({
    queryKey: ["tasks", opts.client ?? "all"],
    queryFn: async () => {
      let q = supabaseAgency.from("linear_issues_cache").select("*")
        .in("bucket", ["overdue", "due_today", "due_this_week"]);
      if (opts.client) q = q.eq("client", opts.client);
      const { data, error } = await q.order("due_date", { ascending: true });
      if (error) throw error;
      const rows = ((data ?? []) as LinearIssueRow[]).map((row) => ({
        task_id: row.issue_id,
        identifier: row.identifier,
        name: row.title,
        status: row.status,
        bucket: row.bucket,
        due_date: row.due_date,
        priority: row.priority,
        list_name: row.project_name,
        project_name: row.project_name,
        assignee_id: row.assignee_id,
        assignee_name: row.assignee_name,
        url: row.url,
        client: row.client,
        synced_at: row.synced_at,
      }));
      const synced_at = rows[0]?.synced_at ?? null;
      return { rows, synced_at };
    },
  });
}
